import React from 'react'
import PropTypes from 'prop-types'
import { LeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { Spin } from 'antd'
import CreateTicketButton from 'components/Header/components/CreateTicketButton/CreateTicketButton'
import { Button } from 'ui/styled'
import NotificationCenter from 'components/NotificationCenter/NotificationCenter'
import ActiveCarePlansDropdown from 'pages/CarePlanDraft/components/ActiveCarePlansDropdown'
import NICMain from 'pages/NIC/Main'
import NICStatusBtn from 'pages/NIC/components/NICStatusBtn/NICStatusBtn'
import { StyledHeader, TitleWrap, Title } from './styled'

const Header = ({
  title,
  isArrowHidden = false,
  buttons = null,
  loading = false,
  pathname = null,
  modalView = false,
  memberId = null,
  isDraftsMenuVisible = false
}) => {
  const navigate = useNavigate()

  const onBackArrowClick = () => (pathname ? navigate(pathname) : navigate(-1))

  return (
    <StyledHeader>
      <TitleWrap>
        {!isArrowHidden && (
          <Button
            btntype="link"
            btnsize="icon"
            margin="0 15px 0 0"
            onClick={() => onBackArrowClick()}
            data-test="headerBackBtn"
          >
            <LeftOutlined />
          </Button>
        )}
        {loading ? <Spin /> : <Title>{title}</Title>}
      </TitleWrap>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginRight: modalView && 15
        }}
      >
        {!modalView && (
          <>
            <NICStatusBtn />
            <NICMain />
          </>
        )}
        {buttons}
        {modalView && memberId && <CreateTicketButton id={memberId} />}
        {!modalView && (
          <>
            {isDraftsMenuVisible && <ActiveCarePlansDropdown />}
            <NotificationCenter />
          </>
        )}
      </div>
    </StyledHeader>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  isArrowHidden: PropTypes.bool,
  loading: PropTypes.bool,
  buttons: PropTypes.array,
  pathname: PropTypes.string,
  modalView: PropTypes.bool,
  memberId: PropTypes.string,
  isDraftsMenuVisible: PropTypes.bool
}

export default Header
